import { DataTable } from 'primereact/datatable'
import CustomModal from '../CustomModal/CustomModal'
import React, { useState } from 'react'
import CustomDataTableHeader from '../CustomDataTableHeader/CustomDataTableHeader'
import { Column } from 'primereact/column'
import { tableCellCenteredWithPercentage } from '../../assets/js/styles'
import { gerarArquivoExcel } from '../../services/util/excel.service'
import BtnIcon from '../BtnIcon/BtnIcon'
import { FaRegFileExcel } from 'react-icons/fa'
import { azul_escuro } from '../../assets/js/colors'

const fieldSizeSelector = field => {
  switch (field) {
    case 'index':
    case '+':
      return 8
    case 'motivo_atraso':
      return 25
    case 'qte_caixas':
    case 'qte_dias':
    case 'horario_saida':
      return 9
    case 'horario_chegada':
      return 13
    case 'identificador':
    case 'data_operacao':
      return 15
    case 'empresa':
      return 12
    case 'vehicle_badge':
    case 'codigo_lacre':
      return 15
    default:
      return 20
  }
}

export default function ModalDataTable({
  fields,
  data,
  onClose,
  title,
  show,
  width,
  fieldParser,
  expander = false,
  expanderTemplateColumn = null,
  expanderDataKey = undefined,
  rowExpansionTemplate = undefined,
  exportButton = false,
  exportFileName = undefined,
}) {
  const [globalFilter, setGlobalFilter] = useState('')
  const [expandedRows, setExpandedRows] = useState(null)

  const onBtnExportClick = data => {
    const ocorrenciasExcel = [Object.keys(data[0])]

    data.forEach(d => {
      ocorrenciasExcel.push(Object.values(d))
    })

    gerarArquivoExcel('sheet1', ocorrenciasExcel, exportFileName + '.xlsx')
  }

  return (
    <CustomModal header={title} isVisible={show} onClose={onClose} width={width}>
      <div className="p-grid">
        <div style={{ marginTop: 5, marginBottom: 5, display: exportButton ? 'block' : 'none' }}>
          <BtnIcon onClick={() => onBtnExportClick(data)}>
            <FaRegFileExcel size={18} color={azul_escuro} />
          </BtnIcon>
        </div>
        <DataTable
          value={data}
          emptyMessage="Não existem dados para serem exibidos"
          paginator={true}
          rows={5}
          globalFilter={globalFilter}
          header={<CustomDataTableHeader onChange={setGlobalFilter} />}
          rowExpansionTemplate={rowExpansionTemplate}
          expandedRows={expandedRows}
          onRowToggle={e => setExpandedRows(e.data)}
          dataKey={expanderDataKey}
          responsive
        >
          {fields.map(field => {
            return expander && field === expanderTemplateColumn ? (
              [
                <Column
                  field={'more'}
                  header={'+'}
                  style={tableCellCenteredWithPercentage(fieldSizeSelector('+'))}
                  expander={true}
                />,
                <Column
                  field={field}
                  header={fieldParser[field]}
                  style={tableCellCenteredWithPercentage(fieldSizeSelector(field))}
                />,
              ]
            ) : (
              <Column
                field={field}
                header={fieldParser[field]}
                style={tableCellCenteredWithPercentage(fieldSizeSelector(field))}
              />
            )
          })}
        </DataTable>
      </div>
    </CustomModal>
  )
}
